'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reduxActions = require('redux-actions');

var _lodash = require('lodash');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Model = function () {
  function Model(config) {
    var _this = this;

    _classCallCheck(this, Model);

    this.reducer = function () {
      var state = arguments.length <= 0 || arguments[0] === undefined ? _this.config.initialState : arguments[0];
      var action = arguments[1];

      var reducerName = _this.fromActionTypeToReducerName(action.type);
      if (_this.config.reducers[reducerName]) {
        return _this.config.reducers[reducerName](state, action);
      }
      if ((0, _lodash.endsWith)(reducerName, 'Success')) {
        // if there's a handler without 'Success' at the end, then use it.
        var defaultReducerName = reducerName.substr(0, reducerName.length - 'Success'.length);
        if (_this.config.reducers[defaultReducerName]) {
          return _this.config.reducers[defaultReducerName](state, action);
        }
      }
      return state;
    };

    this.fromActionTypeToReducerName = function (actionType) {
      return (0, _lodash.camelCase)(actionType.substring(_this.prefix.length));
    };

    this.name = config.name; // used as prefix and to combine reducers.
    this.config = config;
    this.prefix = (0, _lodash.snakeCase)(config.name).toUpperCase() + '_';

    // initialize api. these are the functions that will be
    // used from containers or components. apis will automatically
    // dispatch the result of the underlaying action creator.
    this.api = {};

    // actionCreators are used internally, and could potentially
    // be private (ie: let actionCreators = {};). I leave in case
    // at some point there's the need to create an action without
    // automatically dispatching it.
    this.actionCreators = {};

    this.config.actions.forEach(function (action) {
      var actionName = action.name || action;
      var actionType = _this.prefix + (0, _lodash.snakeCase)(actionName).toUpperCase();
      if (typeof action === 'string') {
        // no need for START/SUCCESS/FAIL SINCE THERE'S NO BUSINESS LOGIC
        _this.actionCreators[actionName] = (0, _reduxActions.createAction)(actionType);
      } else {
        (function () {
          // it should be a named function!!!
          var TYPE_START = actionType + '_STARTED';
          var TYPE_FAIL = actionType + '_FAILED';
          var TYPE_SUCCESS = actionType + '_SUCCESS';
          _this.actionCreators[TYPE_START] = (0, _reduxActions.createAction)(TYPE_START);
          _this.actionCreators[TYPE_SUCCESS] = (0, _reduxActions.createAction)(TYPE_SUCCESS);
          _this.actionCreators[TYPE_FAIL] = (0, _reduxActions.createAction)(TYPE_FAIL);

          _this.actionCreators[actionName] = function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return function (dispatch) {
              var _actionCreators;

              dispatch((_actionCreators = _this.actionCreators)[TYPE_START].apply(_actionCreators, args));
              var result = void 0;
              try {
                var executeAsync = action.bind(_this.api);
                result = executeAsync.apply(undefined, args);
              } catch (error) {
                dispatch(_this.actionCreators[TYPE_FAIL](error));
                throw error;
              }
              if (result && result.then && result.catch) {
                return result.then(function (data) {
                  dispatch(_this.actionCreators[TYPE_SUCCESS](data));
                  return data;
                }).catch(function (err) {
                  dispatch(_this.actionCreators[TYPE_FAIL](err));
                  throw err;
                });
              }
              dispatch(_this.actionCreators[TYPE_SUCCESS](result));
              return result;
            };
          };
        })();
      }
      _this.api[actionName] = function () {
        var _actionCreators2;

        return _this.dispatch((_actionCreators2 = _this.actionCreators)[actionName].apply(_actionCreators2, arguments));
      }; //eslint-disable-line
    });
  }

  _createClass(Model, [{
    key: 'init',
    value: function init(store) {
      var _this2 = this;

      this.dispatch = store.dispatch;
      this.api.getState = store.getState;
      this.api.getMyState = function () {
        return store.getState()[_this2.config.name];
      };
    }
  }]);

  return Model;
}();

exports.default = Model;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-easy-models/lib/index.js
 ** module id = 204
 ** module chunks = 0
 **/